import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const Statistic: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m585 660h-465v-450c0-8.28 6.72-15 15-15s15 6.72 15 15v420h435c8.28 0 15 6.72 15 15s-6.72 15-15 15z' />
    <path d='m188.1 523.1c-12.24-11.16-13.12-30.14-1.96-42.38l147.57-160.59c1.54-1.69 3.39-3.09 5.51-3.96 5.64-2.32 11.85-1.03 16.04 2.9l68.78 64.48 167.42-187.81 22.39 19.96-177.66 199.29c-2.69 3.02-6.49 4.82-10.53 5-4.04.19-7.98-1.28-10.93-4.04l-68.9-64.6-157.74 171.75z' />
    <path d='m630 300h-30v-90h-90v-30h120z' />
    <path d='m660 660h-90s0-30 0-30h60c16.57 0 30 13.43 30 30z' />
    <path d='m120 120v90s30 0 30 0v-60c0-16.57-13.43-30-30-30z' />
  </IconBase>
));

Statistic.displayName = 'Statistic';

export default Statistic;
